export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">移动观看</h2>
            <p className="mt-3 text-foreground-400 text-sm md:text-base leading-relaxed max-w-md mx-auto lg:mx-0">
              八戒电影网已全面适配移动端，手机、平板随时随地高清观影。
              无需下载APP，浏览器直接打开即可享受与桌面端一致的流畅体验。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-4 justify-center lg:justify-start">
              <div className="flex items-center gap-2 text-foreground-400 text-sm">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500/15 rounded-lg">
                  <i className="ri-smartphone-line text-primary-400"></i>
                </div>
                <span>手机浏览器</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-400 text-sm">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500/15 rounded-lg">
                  <i className="ri-tablet-line text-primary-400"></i>
                </div>
                <span>平板适配</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-400 text-sm">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500/15 rounded-lg">
                  <i className="ri-wifi-line text-primary-400"></i>
                </div>
                <span>省流模式</span>
              </div>
            </div>
          </div>
          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative">
              <div className="w-[220px] rounded-2xl overflow-hidden border-2 border-background-300/50 shadow-xl">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20showing%20a%20dark%20themed%20movie%20streaming%20interface%20with%20golden%20accent%20elements%2C%20film%20poster%20thumbnails%20in%20a%20grid%20layout%2C%20elegant%20dark%20UI%20design%2C%20cinematic%20vibe%2C%20minimal%20and%20clean%2C%20no%20text%20visible&width=440&height=880&seq=app-mobile-04&orientation=portrait"
                  alt="八戒电影网 移动端观影"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}